module.exports = __webpack_public_path__ + "static/media/cx.154f56ff.svg";